import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import LightGrayBgWrapper from "../../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import ColoredText from "../../../../components/common/AdminCommonComponents/ColoredText/ColoredText"
import DynamicButton from "../../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDropdown from "../../../../components/common/AdminCommonComponents/DynamicDropdown/DynamicDropdown"
import DynamicDatatable from "../../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import Toggle from "../../../../components/common/AdminCommonComponents/Toggle/Toggle"

const Language = () => {

  const languagesOptions = [
    { label: 'United States Dollar' },
    { label: 'Euro' },
    { label: 'United Arab Emirates Dirham' },
    { label: 'British Pound Sterling' },
  ]

  const languagesTableData = [
    { sr: '1', ID: '001', name: 'English', code: 'USD', status: <Toggle /> },
    { sr: '1', ID: '001', name: 'English', code: 'USD', status: <Toggle /> },
    { sr: '1', ID: '001', name: 'English', code: 'USD', status: <Toggle /> },
    { sr: '1', ID: '001', name: 'English', code: 'USD', status: <Toggle /> },
  ]

  const cols = [
    {
      name: 'Sr#',
      selector: row => row.sr,
    },
    {
      name: 'ID',
      selector: row => row.ID,
    },
    {
      name: 'Name',
      selector: row => row.name,
    },
    {
      name: 'Code',
      selector: row => row.code,
    },
    {
      name: 'Status',
      cell: (row) => row.status
    },
    {
      name: 'Action',
      cell: () => <div className="d-flex flex-column gap-1">
        <button style={{ all: "unset" }}>Edit</button>
        <button style={{ all: "unset" }}>Delete</button>
      </div>
    }
  ];  

  return (
    <LightGrayBgWrapper>
      <Row className="row-cols-1 row-cols-lg-2">
        <Col className="d-grid">
          <div className="p-3 shadow bg-white">
            <div className="d-flex align-items-center justify-content-between">
              <ColoredText color="#EC7426" cn="fs-5 fw-medium">
              Add new language
              </ColoredText>
              <DynamicButton theme="blue">Add</DynamicButton>
            </div>
            <Form className="mt-3" onSubmit={(e) => e.preventDefault()}>
              <FormGroup>
                <Label className="fw-medium" for="languageName">
                Language Name
                </Label>
                <Input id="languageName" name="languageName" placeholder="" type="text" />
              </FormGroup>
              <FormGroup>
                <Label className="fw-medium" for="currencyCode">
                Currency Code
                </Label>
                <Input id="currencyCode" name="currencyCode" placeholder="" type="text" />
              </FormGroup>
              <FormGroup>
                <Label className="fw-medium" for="direction">
                Direction
                </Label>
                <Input id="direction" name="direction" placeholder="" type="text" />
              </FormGroup>
            </Form>
          </div>
        </Col>
        <Col className="d-grid">
          <div className="p-3 shadow bg-white">
            <ColoredText color="#EC7426" cn="fs-5 fw-medium mb-3">
            System Default Language
            </ColoredText>


            <DynamicDropdown options={languagesOptions} />
            <div className="mt-4 text-center">
              <DynamicButton theme="blue">Save</DynamicButton>
            </div>
          </div>
        </Col>
      </Row>

      <div className="mt-3">
        <div className="fw-semibold fs-5 bg-white p-3 shadow rounded-top">Languages</div>

        <DynamicDatatable data={languagesTableData} columns={cols} type='yellow' />
      </div>
    </LightGrayBgWrapper>
  )
}

export default Language
